// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xI9CpPC2wp {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.xI9CpPC2wp h4 {
  line-height: 3em;
}
.xI9CpPC2wp .xtlJh_lWPE {
  float: left;
  width: 100%;
}
.xI9CpPC2wp .l02BpS9mLj {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.xI9CpPC2wp .l02BpS9mLj:hover {
  cursor: pointer;
}
.xI9CpPC2wp .l02BpS9mLj:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.EP_uQiJfzu .d3MJXbhzhL:focus {
  outline: none;
}
.EP_uQiJfzu .d3MJXbhzhL.CVC4wxMyy3.e4CgoiNTt_ {
  background: #375A88;
}
.EP_uQiJfzu .d3MJXbhzhL.CVC4wxMyy3.e4CgoiNTt_ span {
  color: #fff;
}
.EP_uQiJfzu .e4CgoiNTt_ {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.EP_uQiJfzu .e4CgoiNTt_:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.EP_uQiJfzu input {
  height: 38px;
  min-width: 220px;
}
.l02BpS9mLj.CNys_JBFiL {
  background: #410102;
}
.l02BpS9mLj.GVeOx8uYKG {
  background: #911318;
}
.l02BpS9mLj.FgW3ARDutn {
  background: #D8293B;
}
.l02BpS9mLj.G1C99_tzR5 {
  background: #F2373C;
}
.l02BpS9mLj.rIrbKAucji {
  background: #FC4448;
}
.l02BpS9mLj.KydixPZDVT {
  background: #ED535E;
}
.l02BpS9mLj.sY3U8hVvPk {
  background: #E34926;
}
.l02BpS9mLj.LxCLcks_Mj {
  background: #FC562B;
}
.l02BpS9mLj.yh6WSFLxU6 {
  background: #FC6722;
}
.l02BpS9mLj.WaHMvKSISi {
  background: #FD7F24;
}
.l02BpS9mLj.JBUDQUTokX {
  background: #FD8D26;
}
.l02BpS9mLj.cOWq1_xPoZ {
  background: #EC9C3E;
}
.l02BpS9mLj.yLmtG16DCR {
  background: #0e673a;
}
.l02BpS9mLj.rEg4aefwft {
  background: #208740;
}
.l02BpS9mLj.EkMThCchlf {
  background: #239718;
}
.l02BpS9mLj.mOxpYLXBWO {
  background: #55A84D;
}
.l02BpS9mLj.sUeyaPMLVY {
  background: #4BBE5A;
}
.l02BpS9mLj.SFqiAYtXUQ {
  background: #0CCA6A;
}
.l02BpS9mLj.S8wedw9FNo {
  background: #0A3C64;
}
.l02BpS9mLj.Q4oYgKiGtC {
  background: #0d487a;
}
.l02BpS9mLj.ZyyD1fPv7f {
  background: #10538d;
}
.l02BpS9mLj.DSt4N_UxL0 {
  background: #115A99;
}
.l02BpS9mLj.tvFjY5HcQN {
  background: #3387E2;
}
.l02BpS9mLj._mrusp8Fw3 {
  background: #1BA9CF;
}
.l02BpS9mLj.qKNz_R_czz {
  background: #d27c02;
}
.l02BpS9mLj.pLfwzz7Sb5 {
  background: #fb9402;
}
.l02BpS9mLj.BrkNdnHL7Z {
  background: #FD9B30;
}
.l02BpS9mLj.Q1S9tg9MFt {
  background: #FDBE2D;
}
.l02BpS9mLj.wjxipJw9EH {
  background: #FED831;
}
.l02BpS9mLj.YSJOehguC_ {
  background: #FFFD38;
}
.l02BpS9mLj.htG1jiMA13 {
  background: #2D215C;
}
.l02BpS9mLj.Vw0PzG4Ljy {
  background: #483C83;
}
.l02BpS9mLj.sN9YIZxE8w {
  background: #58518d;
}
.l02BpS9mLj.kSnAHYOCaf {
  background: #7068A9;
}
.l02BpS9mLj.umFSSe9cJt {
  background: #7f78b2;
}
.l02BpS9mLj.ZxAztlt4NK {
  background: #8f88bc;
}
.l02BpS9mLj.zv39jAB_KB {
  background: #000;
}
.l02BpS9mLj.q1sNKXtUq4 {
  background: #282626;
}
.l02BpS9mLj.EijALwTCrn {
  background: #242222;
}
.l02BpS9mLj.wJpbylDNaV {
  background: #353838;
}
.l02BpS9mLj.Js8yq5NcTD {
  background: #666;
}
.l02BpS9mLj.THR_7cBvXA {
  background: #999;
}
.eQvUvwwTZG {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.eQvUvwwTZG .wlRPy1NHDx {
  display: none;
}
.Bz2XLBUynr {
  min-width: calc(800px - 36px * 2);
  margin: 20px;
  margin-left: 36px;
  margin-right: 36px;
}
.Bz2XLBUynr .WhyZ1h_tPW {
  min-height: 143px;
}
.Bz2XLBUynr .WhyZ1h_tPW > p {
  font-weight: 700;
  font-size: 14px;
  color: #737D86;
}
.Bz2XLBUynr .WhyZ1h_tPW .M_FuXHAF6l {
  font-size: 10px;
  font-weight: 300;
}
._3cN4I7TKe .CWFvaVGR7e.CWFvaVGR7e {
  background-color: #f5f6f7;
}
._3cN4I7TKe .CWFvaVGR7e.CWFvaVGR7e:hover {
  background-color: #f5f6f7;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `xI9CpPC2wp`,
	"color-row": `xtlJh_lWPE`,
	"color-tile": `l02BpS9mLj`,
	"picker-component": `EP_uQiJfzu`,
	"picker-element": `d3MJXbhzhL`,
	"active": `CVC4wxMyy3`,
	"btn": `e4CgoiNTt_`,
	"red-1": `CNys_JBFiL`,
	"red-2": `GVeOx8uYKG`,
	"red-3": `FgW3ARDutn`,
	"red-4": `G1C99_tzR5`,
	"red-5": `rIrbKAucji`,
	"red-6": `KydixPZDVT`,
	"orange-1": `sY3U8hVvPk`,
	"orange-2": `LxCLcks_Mj`,
	"orange-3": `yh6WSFLxU6`,
	"orange-4": `WaHMvKSISi`,
	"orange-5": `JBUDQUTokX`,
	"orange-6": `cOWq1_xPoZ`,
	"green-1": `yLmtG16DCR`,
	"green-2": `rEg4aefwft`,
	"green-3": `EkMThCchlf`,
	"green-4": `mOxpYLXBWO`,
	"green-5": `sUeyaPMLVY`,
	"green-6": `SFqiAYtXUQ`,
	"blue-1": `S8wedw9FNo`,
	"blue-2": `Q4oYgKiGtC`,
	"blue-3": `ZyyD1fPv7f`,
	"blue-4": `DSt4N_UxL0`,
	"blue-5": `tvFjY5HcQN`,
	"blue-6": `_mrusp8Fw3`,
	"yellow-1": `qKNz_R_czz`,
	"yellow-2": `pLfwzz7Sb5`,
	"yellow-3": `BrkNdnHL7Z`,
	"yellow-4": `Q1S9tg9MFt`,
	"yellow-5": `wjxipJw9EH`,
	"yellow-6": `YSJOehguC_`,
	"purple-1": `htG1jiMA13`,
	"purple-2": `Vw0PzG4Ljy`,
	"purple-3": `sN9YIZxE8w`,
	"purple-4": `kSnAHYOCaf`,
	"purple-5": `umFSSe9cJt`,
	"purple-6": `ZxAztlt4NK`,
	"black-1": `zv39jAB_KB`,
	"black-2": `q1sNKXtUq4`,
	"black-3": `EijALwTCrn`,
	"black-4": `wJpbylDNaV`,
	"black-5": `Js8yq5NcTD`,
	"black-6": `THR_7cBvXA`,
	"picker-theme": `eQvUvwwTZG`,
	"arrow-regular": `wlRPy1NHDx`,
	"uploaderRoot": `Bz2XLBUynr`,
	"uploaderDropzone": `WhyZ1h_tPW`,
	"uploaderText": `M_FuXHAF6l`,
	"dropzone__select-option--root": `_3cN4I7TKe`,
	"dropzone__select-option--label": `CWFvaVGR7e`
};
export default ___CSS_LOADER_EXPORT___;
